<template>
    <section class="app-main">
        <el-row class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()">添加</el-button >
        </el-row>

        <el-card>
            <el-table :data="tableData"  max-height="650" style="width: 100%">
                <el-table-column label="中文图标" align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.logo_pic_url" :src="scope.row.logo_pic_url" :width="160" :height="160" />
                    </template>
                </el-table-column>
                <el-table-column prop="title"   align="center" label="中文名称"></el-table-column>
                <el-table-column prop="link"   align="center" label="中文链接"></el-table-column>
                <el-table-column label="英文图标" align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.logo_pic_url_en" :src="scope.row.logo_pic_url_en" :width="160" :height="160" />
                    </template>
                </el-table-column>
                <el-table-column prop="title_en" align="center" label="英文名称"></el-table-column>
                <el-table-column prop="link_en"   align="center" label="英文链接"></el-table-column>
                <el-table-column prop="color"    align="center" label="背景色"></el-table-column>
                <el-table-column  prop="sort" align="center" label="排序" sortable>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort" @change="onSort(scope.row)" size="mini" style="width:65px"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" @change="handleStatus(scope.row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center" width="180">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger" plain size="mini"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination> -->
        </el-card>

        <el-dialog title="主题设置" :visible.sync="dialog" width="800px">
            <el-card class="m-bottom-4">
                    <el-row class="m-bottom-4">
                        <el-col :span="3" class="input-left">
                            中文名称：
                        </el-col>
                        <el-col :span="21">
                            <el-input v-model="title" placeholder="请输入中文名称" style="width:220px"></el-input>
                        </el-col>
                    </el-row>
                    <el-row class="m-bottom-4">
                        <el-col :span="3" class="input-left">
                            中文链接：
                        </el-col>
                        <el-col :span="21">
                            <el-input v-model="link" placeholder="请输入跳转链接" style="width:220px"></el-input>
                        </el-col>
                    </el-row>
                    <el-row class="m-bottom-4">
                        <el-col :span="3" class="input-left">
                            中文图标：
                        </el-col>
                        <el-col :span="21" class="uploadImage">
                            <m-upload :img.sync="image"  :width="100" :height="100" file-name="Banner"  placement="right" />
                            <div class="suggest-size">
                                （*建议尺寸比例1:1，图片大小超过1M）
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="m-bottom-4">
                    <el-row class="m-bottom-4">
                        <el-col :span="3" class="input-left">
                            英文名称：
                        </el-col>
                        <el-col :span="21">
                            <el-input v-model="title_en" placeholder="请输入英文名称" style="width:220px"></el-input>
                        </el-col>
                    </el-row>
                    <el-row class="m-bottom-4">
                        <el-col :span="3" class="input-left">
                            英文链接：
                        </el-col>
                        <el-col :span="21">
                            <el-input v-model="link_en" placeholder="请输入跳转链接" style="width:220px"></el-input>
                        </el-col>
                    </el-row>
                    <el-row class="m-bottom-4">
                        <el-col :span="3" class="input-left">
                            英文图标：
                        </el-col>
                        <el-col :span="21" class="uploadImage">
                            <m-upload :img.sync="imgEn"  :width="100" :height="100" file-name="Banner"  placement="right" />
                            <span class="suggest-size">
                                （*建议尺寸比例1:1，图片大小超过1M）
                            </span>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="m-bottom-4">
                    <el-row>
                        <el-col :span="3" class="input-left">
                            主题背景：
                        </el-col>
                        <el-col :span="21">
                            <el-input v-model="color" placeholder="请输入背景色（选填）" style="width:220px">
                                <colorPicker v-model="color" class="color_select" slot="prefix" />
                            </el-input>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card>
                    <el-row class="m-bottom-4">
                        <el-col :span="3" class="input-left">
                            提交信息：
                        </el-col>
                        <el-col :span="21">
                            <el-button :disabled="disabled"  @click="handleBtn()" type="success" plain>确认提交</el-button>
                        </el-col>
                    </el-row>
                </el-card>
        </el-dialog>
            
        
    </section>
</template>
<script>
import { subject, subject_add, subject_put, subject_del } from '@/api/market.js'
import MUpload from '@/components/m-upload.vue'
import MImg   from './../../../components/Image'
export default {
    name:'GoodsEdit',
    components:{ MUpload, MImg },
    data () {
        return {
            image: { url: '', pic_id: '' },   // 中文主图
            imgEn: { url: '', pic_id: '' },   // 英文主图
            id        : '',
            link: '',
            link_en: '',
            title     : '',
            title_en  : '',
            color     : '', 
            tableData: [],
            total: 0,
            page: 1,
            size: 20,
            disabled: false,
            dialog: false,
        }
    },
    methods:{
        // 重置数据
        resetBanner() {
            this.image.pic_id = ''
            this.image.url    = ''
            this.imgEn.pic_id = ''
            this.imgEn.url    = ''
            this.id        = ''
            this.title     = ''
            this.title_en  = ''
            this.color     = ''
        },
         // 获取商品详情
        getDetail() {
          let params = {
              page: 1
          }  
          subject(params).then(res => {
            if(res) {
              this.tableData = res.data
            }
            
          })
        },
        // 修改排序
        onSort(row) {
            let params = {
                sort: row.sort
            }
            subject_put(row.id,params).then(res => {
                if(res) {
                    this.$message({type:'success',message:res.msg})
                    this.tableData = this.$.sortBy(this.tableData, (it) => {
                        return -it.sort
                    })
                }
            })
        },
        // 状态修改
        handleStatus(row) {
            let params = {
                status: row.status
            }
            subject_put(row.id,params).then(res => {
                if(res) {
                    this.$message({type:'success',message:res.msg})
                    this.getDetail()
                }
            })
        },
         // 显示添加修改弹窗
        handleShow(row){
            if(row){
                this.dialog      = true
                this.id          = row.id
                this.title       = row.title
                this.title_en    = row.title_en
                this.link        = row.link
                this.link_en     = row.link_en
                this.color       = row.color
                if(row.logo_pic_url) {
                    this.image.pic_id = row.logo_id
                    this.image.url    = row.logo_pic_url
                }else {
                    this.image.pic_id = ''
                    this.image.url    = ''
                }
                if(row.logo_pic_url_en) {
                    this.imgEn.pic_id = row.logo_id_en
                    this.imgEn.url    = row.logo_pic_url_en
                }else {
                    this.imgEn.pic_id = ''
                    this.imgEn.url    = ''
                }
                
            }else{
                this.dialog     = true
                this.resetBanner()
            }
        },
        // 点击提交按钮  有id修改 无id添加  
        handleBtn() {
            if(this.id == '') {
                this.handleAdd()
            }else {
                this.handlePut()
            }
        },
        // 添加轮播图
        handleAdd() {
            if(this.image.pic_id == ''){
                return false
            }
            if(this.imgEn.pic_id == ''){
                return false
            }
            if(this.title == ''){
                return false
            }
            if(this.title_en == ''){
                return false
            }
            if(this.link == ''){
                return false
            }
            if(this.link_en == ''){
                return false
            }
            if(this.color == ''){
                return false
            }
            this.disabled = true
            let params = {
                title: this.title,
                title_en: this.title_en,
                logo_id: this.image.pic_id,
                logo_id_en: this.imgEn.pic_id,
                color: this.color,
                link: this.link,
                link_en: this.link_en
            }
            subject_add(params).then(res => {
                if(res) {
                    this.getDetail()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            }).finally( ()=> {
                this.dialog   = false
                this.disabled = false
            })
        },
        // 修改轮播图
        handlePut() {
            if(this.image.pic_id == ''){
                return false
            }
            if(this.imgEn.pic_id == ''){
                return false
            }
            if(this.title == ''){
                return false
            }
            if(this.title_en == ''){
                return false
            }
            if(this.color == ''){
                return false
            }
            if(this.link == ''){
                return false
            }
            if(this.link_en == ''){
                return false
            }
            this.disabled = true
            let params = {
                title: this.title,
                title_en: this.title_en,
                logo_id: this.image.pic_id,
                logo_id_en: this.imgEn.pic_id,
                color: this.color,
                link: this.link,
                link_en: this.link_en
            }
            subject_put(this.id, params).then(res => {
                if(res) {
                    this.getDetail()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            }).finally( ()=> {
                this.disabled = false
                this.dialog   = false
            })
        },
        // 删除
        handleDel(row) {
            subject_del(row.id).then(res => {
                if(res) {
                    this.$message({type:'success',message:res.msg})
                    this.getDetail()
                }
            })
        }
    },
    created(){
        this.getDetail()
    },
    activated() {
        this.getDetail()
    },
}
</script>
<style lang="less" scoped>
section {
    .top-btn {
        width: 120px;
    }
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    
    /deep/  .el-input--mini .el-input__inner  {
        text-align: center;
        width: 60px;
    }   

    .uploadImage {
        display: flex;
    }

    .suggest-size {
        line-height: 100px;
        color: grey;
        font-size: 0.9em;
    }
    /deep/ .el-input__prefix {
        line-height: 40px;
    }
    /deep/ .color_select {
        cursor: pointer;
    }
    /deep/ .el-card {
        overflow: unset;
    }
}
</style>

